import { EvaluationType, SlaStatus } from '../api/enumerations';

export type SlaTone = 'overdue' | 'near' | 'ok' | 'unknown';

export const SLA_COLORS: Record<SlaTone, string> = {
  overdue: '#F50606',
  near: '#E67715',
  ok: '#4CAF50',
  unknown: '#9E9E9E',
};

export const SLA_TONE_LABEL: Record<SlaTone, string> = {
  overdue: 'atrasada',
  near: 'próx. prazo',
  ok: 'no prazo',
  unknown: '—',
};

export const SLA_LABEL: Record<SlaStatus, string> = {
  [SlaStatus.ON_TRACK]: 'no prazo',
  [SlaStatus.NEAR_DEADLINE]: 'próximo do prazo',
  [SlaStatus.OVERDUE]: 'atrasada',
};

export const SLA_OPTIONS: SlaStatus[] = [
  SlaStatus.ON_TRACK,
  SlaStatus.NEAR_DEADLINE,
  SlaStatus.OVERDUE,
];

export const slaTone = (status: SlaStatus | null): SlaTone => {
  if (status === SlaStatus.OVERDUE) return 'overdue';
  if (status === SlaStatus.NEAR_DEADLINE) return 'near';
  if (status === SlaStatus.ON_TRACK) return 'ok';
  return 'unknown';
};

export const EVALUATION_TYPE_OPTIONS: EvaluationType[] = [
  EvaluationType.AUTOFACTORS,
  EvaluationType.AUTOINFERENCES,
  EvaluationType.SIMPFACTORS,
  EvaluationType.SIMPINFERENCES,
  EvaluationType.COMPLETEFACTORS,
  EvaluationType.COMPLETEINFERENCES,
  EvaluationType.EVOLUTIVE,
  EvaluationType.INVOLUTIVE,
];

export const Constants = {
  bankTitle: 'Ordens de serviço',
  bankSubtitle: 'Acompanhe cada OS do pedido à entrega do laudo',
  buttonAdd: 'Nova OS',
  DesktopMode: 'Modo desktop',
  os: 'número OS:',
  client: 'cliente:',
  clientType: 'tipo do cliente:',
  address: 'localização:',
  report: 'modalidade:',
  goal: 'objetivo:',
  function: 'finalidade:',
  inspector: 'vistoriador:',
  schedule: 'agendamento:',
  limitFinish: 'limite para entrega:',
  reason: 'motivo:',
  company: 'empresa:',
  requestRejected: 'pedido recusado',
  tableEmpty:
    'Nenhuma ordem de serviço com esses filtros. Elas aparecem aqui assim que entrarem no fluxo.',
  clearFilters: 'Limpar filtros',
  loadMore: 'Carregar mais',
  collapseColumn: 'Recolher coluna',
  expandColumn: 'Expandir coluna',
  expandAllColumns: 'Expandir todas as colunas',
  sortNewest: 'Ordenar: mais recentes primeiro',
  sortOldest: 'Ordenar: mais antigas primeiro',
};
